import { Widget } from '../base/widget/WidgetInterface'
import { WidgetType } from '../base/widget/WidgetTypes'

export const WidgetReport: Widget = {
  type: WidgetType.report,
  title: 'Neueste Meldungen',
  defaultSize: 8,
  minSize: 6,
  maxSize: 0,
  minHeight: 7,
  icon: 'Newspaper'
}

export default WidgetReport
